export const Browsers = {
  pE: "Chrome",
  xE: "Edge",
  oc: "Internet Explorer",
  FE: "Opera",
  Bg: "Safari",
  ME: "Firefox",
};
export const OperatingSystems = {
  xg: "Android",
  de: "iOS",
  kg: "Mac",
  Pg: "Windows",
};
